import { IconButton } from '@components/core/icon-button.component';
import { cn } from '@lib/utils';
import { PanelLeft, PanelRight, XIcon } from 'lucide-react';

type AssessmentLayoutProps = {
  assessmentLabel: string;
  children: React.ReactNode;
  leftSidebar: React.ReactNode;
  onExit: () => void;
  onToggleLeft: () => void;
  onToggleRight?: () => void;
  rightSidebar?: React.ReactNode;
  rightSidebarAriaLabel?: string;
  shellClassName?: string;
  statusLabel?: string;
  technologyName?: string;
};

export const AssessmentLayout: React.FC<AssessmentLayoutProps> = (props) => {
  const {
    assessmentLabel,
    children,
    leftSidebar,
    onExit,
    onToggleLeft,
    onToggleRight,
    rightSidebar,
    rightSidebarAriaLabel,
    shellClassName,
    statusLabel,
    technologyName,
  } = props;

  return (
    <div className="flex h-[calc(100svh-var(--impersonation-banner-height,0px))] w-full flex-col">
      <div
        className="flex h-[52px] items-center justify-between pl-3"
        style={{
          background:
            'linear-gradient(180deg, #36344D 0%, #090534 100%), radial-gradient(15.31% 104.79% at 79.99% 100%, rgba(61, 46, 255, 0.4) 0%, rgba(61, 46, 255, 0) 100%)',
        }}
      >
        <div
          className="flex items-center gap-x-[8px] pt-[2px] text-base font-light text-[#FFFFFFB2]"
          onClick={onToggleLeft}
        >
          <IconButton
            ariaLabel="Toggle sidebar"
            className="bg-transparent hover:bg-white/20"
            icon={<PanelLeft />}
          />
          <div className="pt-[2px]">
            <span className="font-medium text-[#FFFFFF]">{technologyName ?? '...'}</span> | {assessmentLabel}
            {statusLabel ? ` | ${statusLabel}` : null}
          </div>
        </div>
        <div className="flex items-center gap-x-2 pr-[12px]">
          {rightSidebar && (
            <IconButton
              ariaLabel={rightSidebarAriaLabel ?? 'Toggle context sidebar'}
              className="bg-transparent hover:bg-white/20"
              icon={<PanelRight />}
              onClick={onToggleRight}
            />
          )}
          <IconButton
            ariaLabel="Exit assessment"
            className="bg-transparent hover:bg-white/20"
            icon={<XIcon />}
            onClick={onExit}
          />
        </div>
      </div>

      <div className={cn('@container/survey-shell flex min-h-0 flex-1', shellClassName)}>
        {leftSidebar}

        <div className="min-h-0 flex-1 overflow-y-auto">
          <div className="mx-auto w-full max-w-(--breakpoint-lg)">{children}</div>
        </div>

        {rightSidebar}
      </div>
    </div>
  );
};
